import { render, staticRenderFns } from "./LoadingImage.vue?vue&type=template&id=b3b37a88&scoped=true&"
import script from "./LoadingImage.vue?vue&type=script&lang=js&"
export * from "./LoadingImage.vue?vue&type=script&lang=js&"
import style0 from "./LoadingImage.vue?vue&type=style&index=0&id=b3b37a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b37a88",
  null
  
)

export default component.exports